module.exports = __webpack_public_path__ + "img/i-cards-white.3ab309af.svg";